import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { CpsSearchQueryResult, CpsSearchQueryRequest, CpsSearchExportRequest } from '@cs-cms/types';

interface ISearchContext {
  data?: CpsSearchQueryResult;
  isLoading?: boolean;
  queryRequest?: CpsSearchQueryRequest;
  setQueryRequest: Dispatch<SetStateAction<CpsSearchQueryRequest | undefined>>;
  compositeFilterDescriptor?: CompositeFilterDescriptor;
  setCompositeFilterDescriptor?: (newCompositeFilterDescriptor: CompositeFilterDescriptor | undefined) => void;
  handleTriggerExportToCsv?: (querySearchExport: CpsSearchExportRequest) => void;
}

const defaultValue: ISearchContext = {
  setQueryRequest: () => {}
};

export const SearchContext = createContext<ISearchContext>(defaultValue);

export const useSearchContext = () => useContext(SearchContext);
